import Marquee from "react-fast-marquee";

const ITEMS = [
  "Artificial Intelligence", "Automation", "Software Engineering", "Smart Home",
  "Cloud Native", "RAG Systems", "AI Agents", "Digital Transformation", "Microservices",
];

export default function BrandMarquee({ dark = true }) {
  return (
    <div className={`border-y ${dark ? "border-white/10 bg-[#07111F]" : "border-slate-200 bg-[#F8FAFC]"} py-6`} data-testid="brand-marquee">
      <Marquee speed={34} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center gap-8 px-8">
            <span className={`font-display text-xl font-medium tracking-tight ${dark ? "text-slate-300" : "text-slate-600"}`}>{t}</span>
            <span className="h-1.5 w-1.5 rounded-full accent-bg" />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
